export const isAttributeVisible = (definition, currentValues = {}) => {
  const conditions = definition?.conditions || [];
  if (!conditions.length) return true;

  return conditions.every(
    condition =>
      String(currentValues[condition.attribute_key]) === String(condition.value)
  );
};
